@if (pureFilterStream$ | async; as filter) {
  @if (filter.removable) {
    <div class="sh-input-field-with-action">
      <div class="sh-input-field-with-action__input sh-clear-margin-right">
        <ng-container *ngTemplateOutlet="filterItem"></ng-container>
      </div>
      <button class="sh-input-field-with-action__action sh-pure-icon-button--small" (click)="onRemoveFilter()">
        <svg sh-icon [size]="IconSizes.SMALL" [name]="'delete'" class="sh-icon-button__icon" aria-hidden="true"></svg>
      </button>
    </div>
  } @else {
    @switch (filter.filterType) {
      @case (FilterType.MultiSelect) {
        <sh-filter-multiselect
          [loading]="loading$ |async "
          [filter]="filter"
          [i18n]="i18n?.filterMultiSelect"
          (filterChanged)="onFilterChange($event)"
          >
        </sh-filter-multiselect>
      }
      @case (FilterType.Date) {
        <sh-filter-date
          [filter]="filter"
          [i18n]="i18n?.filterDate"
          (filterChanged)="onFilterChange($event)"
        ></sh-filter-date>
      }
    }
  }
  <ng-template #filterItem>
    @switch (filter.filterType) {
      @case (FilterType.MultiSelect) {
        <sh-filter-multiselect
          [loading]="loading$ |async "
          [filter]="filter"
          [i18n]="i18n?.filterMultiSelect"
          (filterChanged)="onFilterChange($event)"
          >
        </sh-filter-multiselect>
      }
      @case (FilterType.Date) {
        <sh-filter-date
          [filter]="filter"
          [i18n]="i18n?.filterDate"
          (filterChanged)="onFilterChange($event)"
        ></sh-filter-date>
      }
    }
  </ng-template>
}
